import {createAsyncThunk} from '@reduxjs/toolkit';
import api, {CustomAxiosConfig} from 'services/axios';

type GetNotificationParams = {
  vendor_id: string | number;
  page: number;
  page_size: number;
  topic: string;
};

type ViewNotificationParams = {
  vendor_id: string | number;
  ids: string[];
};

type ReadNotificationParams = {
  vendor_id: string | number;
  id: string;
};

type NotificationParams = {
  vendor_id: string | number;
  id?: number;
  token?: string;
  platform?: string;
  device_id?: number | null;
};

type NotificationResponse = {
  data: any;
};

export const registerToken = createAsyncThunk<NotificationResponse, NotificationParams>(
  'registerToken',
  async (data, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/notification/register?vendor_id=${data.vendor_id}`,
        data,
        {
          goBaseUrl: true
        } as CustomAxiosConfig
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const unregisterToken = createAsyncThunk<NotificationResponse, NotificationParams>(
  'unregisterToken',
  async (params, thunkApi) => {
    try {
      const response = await api.delete(`/dasht/notification/unregister`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const listNotifications = createAsyncThunk<NotificationResponse, GetNotificationParams>(
  'listNotifications',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/notification`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const readNotification = createAsyncThunk<NotificationResponse, ReadNotificationParams>(
  'readNotification',
  async (data, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/notification/${data.id}/ack?vendor_id=${data.vendor_id}`,
        data,
        {
          goBaseUrl: true
        } as CustomAxiosConfig
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const viewNotifications = createAsyncThunk<NotificationResponse, ViewNotificationParams>(
  'viewNotifications',
  async (data, thunkApi) => {
    try {
      const response = await api.put(`/dasht/notification/syn?vendor_id=${data.vendor_id}`, data, {
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const pollNotification = createAsyncThunk<NotificationResponse, NotificationParams>(
  'pollNotification',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/notification/poll`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
